import { MarkersOfSuccessPage } from './MarkersOfSuccessPage';

export const MarkersOfSuccessPageContainer = () => {
  return <MarkersOfSuccessPage />;
};
